import { render, staticRenderFns } from "./RestaurantBookingSettingsCard.vue?vue&type=template&id=dd27d0f0"
import script from "./RestaurantBookingSettingsCard.vue?vue&type=script&lang=ts"
export * from "./RestaurantBookingSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports